export default [{
    title: "Ventas Nacionales",
    icon: "FlagIcon",
    resource: "Ventas Nacionales",
    action: "ver-ventas-nacionales",
    children: [{
        title: "Dashboard",
        icon: "LayoutIcon",
        resource: "Ventas Nacionales",
        action: "ver-ventas-nacionales-dashboard",
    }, {
        title: "Configuracion",
        icon: "SettingsIcon",
        resource: "Ventas Nacionales",
        action: "ver-ventas-nacionales-configuracion",
    }, {
        title: "Mantenimiento",
        icon: "EditIcon",
        resource: "Ventas Nacionales",
        action: "ver-ventas-nacionales-mantenimiento",
    }, {
        title: "Transacciones",
        fontIcon: "exchange-alt",
        resource: "Ventas Nacionales",
        action: "ver-ventas-nacionales-transacciones",
    }, {
        title: "Informes",
        fontIcon: "file-prescription",
        resource: "Ventas Nacionales",
        action: "ver-ventas-nacionales-informes",
        children: [{
            route: "ventas-nacionales-resumen-ventas",
            title: "Resumen Ventas",
            resource: "Ventas Nacionales",
            action: "ver-ventas-nacionales-resumen-ventas",
        }, {
            route: "ventas-nacionales-detalles-ventas-canal",
            title: "Det. Ven. Canal",
            resource: "Ventas Nacionales",
            action: "ver-ventas-nacionales-detalle-venta-canal",
        }, {
            route: "ventas-nacionales-detalles-ventas-cliente",
            title: "Det. Ven. Cliente",
            resource: "Ventas Nacionales",
            action: "ver-ventas-nacionales-detalle-venta-cliente",
        }, {
            route: "ventas-nacionales-detalles-ventas-item",
            title: "Det. Ven. Item",
            resource: "Ventas Nacionales",
            action: "ver-ventas-nacionales-detalle-venta-item",
        }, {
            route: "ventas-nacionales-detalles-rentabilidad-canal",
            title: "Det. Ren. Canal",
            resource: "Ventas Nacionales",
            action: "ver-ventas-nacionales-detalle-rentabilidad-canal",
        }, {
            route: "ventas-nacionales-detalles-rentabilidad-autoservicio",
            title: "Det. Ren. Autoservicio",
            resource: "Ventas Nacionales",
            action: "ver-ventas-nacionales-detalle-rentabilidad-autoservicio",
        }, ]
    }, ]
}]